import { Action, createReducer, on } from '@ngrx/store';
import * as quotationsActions from './quotes.actions';
import { IQuotation, IQuotationDetail } from '../models/quotes.models';

export interface quotationsState {
  quotations: IQuotation[];
  quotation: IQuotationDetail | undefined;
}

export const initialquotationsState: quotationsState = {
  quotations: [],
  quotation: undefined,
};

const featureReducer = createReducer(
  initialquotationsState,
  on(quotationsActions.GetQuotationsSuccess, (state, action) => ({
    ...state,
    quotations: action.quotations,
  })),
  on(quotationsActions.GetQuotationByIdSuccess, (state, action) => ({
    ...state,
    quotation: action.quotation,
  })),
  on(quotationsActions.clearQuotation, (state, action) => ({
    ...state,
    quotation: undefined,
  }))
);

export function quotationsReducer(state: quotationsState | undefined, action: Action) {
  return featureReducer(state, action);
}
